import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import {FormControl, InputLabel, Input, FormHelperText, Alert} from '@mui/material';
import WebService from '@util/webService'
import { truncate, isAdmin} from '@util/helper'
// redux
import {useSelector, useDispatch} from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import {useTable, useExpanded} from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { setSchola } from '@redux/actions/scholaAction';
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Snackbar,
  TablePagination,
  TextField,
  withStyles,
  InputBase,
  Chip,
} from '@mui/material';
import {tablePaginationClasses} from '@mui/material/TablePagination'
import {styled, alpha} from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import {useTheme} from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

// date
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import moment from 'moment';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Autocomplete, {createFilterOptions} from '@mui/material/Autocomplete';
import {searchSchool} from '@util/helper';
import ManagerSmstPart from './manager-smst.part';
import ManagerNoticePartMod from "@pages/manager/manager-notice.part.mod";
import TransDialog from "@components/TransDialog";
import ConfirmDialog from "@components/ConfirmDialog";
import {Link} from "react-router-dom";
import ManagerNoticePartView from "@pages/manager/manager-notice.part.view";
import useAlert from "@hooks/useAlert";
import {useParams} from "react-router-dom";
import Hashids from 'hashids';
import { useLocation } from 'react-router-dom';
import ManagerChatPartDialog from './manager-chat.part.dialog';
import ManagerChatPartSetting from './manager-chat.part.setting';
import MyDialog3 from '@components/MyDialog3';
import SettingsIcon from '@mui/icons-material/Settings'

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const hashids = new Hashids('', 5)
const ReadBadge = ({ count }) => {
  const unread = Number(count) > 0
  const colors = unread
    ? { color: '#b71c1c', borderColor: '#b71c1c', backgroundColor: '#ffebee' }
    : { color: '#17B2F9', borderColor: '#17B2F9', backgroundColor: '#EDFAFE' }
  return (
    <Chip
      size="small"
      variant="outlined"
      label={unread ? `읽지 않음: ${count}` : '모두 읽음'}
      sx={{
        ...colors,
        fontWeight: 'bold',
        // 한글 폰트가 영문 기준 줄 높이에서 위로 떠 보여 라벨만 살짝 내림
        '& .MuiChip-label': { lineHeight: 1, paddingTop: '2px' },
      }}
    />
  )
}
const pageSize = 30
const ManagerChatPage = () => {
  console.log('ManagerChatPage rendering...')
  const inputRef = useRef(null)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const {more} = useParams()

  const fields = [
    { field: 'id', placeholder: '아이디', type: 'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList: [],  },
    {field: 'unreadCount', placeholder: '읽음여부', type: 'text', value: 0, visible: true, canSrch: false, selList: [], width:100},
    {field: 'uptTime', placeholder: '수정일시', type: 'text', value: '', visible: true, canSrch: false, selList: [], width:200 },
    {field: 'userAlias', placeholder: '작성자', type: 'text', value: '', visible: true, canSrch: false, selList: [], width:300},
    {field: 'lectureTitle', placeholder: '관련강좌', type: 'text', value: '', visible: true, canSrch: false, selList: [], width:200},
    {field: 'ctnt', placeholder: '내용', type: 'text', value: '', visible: true, canSrch: false, selList: []},
  ]

  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })


  defRecord.schoolList = []
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [dataList, set_dataList] = useState([])

  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(30)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum: 0, pageSize: pageSize})
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const termsRef = useRef(terms)
  const [schoolGroup, set_schoolGroup] = useState([])
  const modHandler = useState(false)
  const viewHandler = useState(false)
  const settingHandler = useState(false)
  const [modOpen, set_modOpen] = useState(false)
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const {alert, renderAlert} = useAlert()
  const location = useLocation()
  const curLocationRef = useRef(location)
  const recordRef = useRef(defRecord)
  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }

  const [unreadOnly, set_unreadOnly] = useState(false)
  const [keywordInput, set_keywordInput] = useState('')
  const [keyword, set_keyword] = useState('')

  const renderCell = (row, col, colIdx) => {
    if(col.field === 'ctnt') {
      return (
        <TableCell key={colIdx} style={{ cursor: 'pointer', }} onClick={() => { modHandler[1](true) }}>
          <Typography variant='body2' fontWeight='bold'>
            {truncate(row.content)}
          </Typography>
          <Typography variant='body2' style={{marginTop:10}}>
            {truncate(row.lastContent)}
          </Typography>
        </TableCell>
      )
    }
    else if(col.field === 'unreadCount') {
      return (
        <TableCell key={colIdx} >
          <ReadBadge count={row.unreadCount} />
        </TableCell>
      )
    }
    else if(col.field === 'uptTime' || col.field === 'userAlias' || col.field === 'lectureTitle') {
      return (
        <TableCell key={colIdx}>
          <Typography variant='body2'>{row[col.field]}</Typography>
        </TableCell>
      )
    }
    else {
      return <TableCell key={colIdx}  >{row[col.field]}</TableCell>
    }
  }

  const onLoad = async () => {

    const info = await fetchChats()
    if(info) {
      const records = JSON.parse(info.records)
      // for (const record of records) {
      //   record.ctnt = `<Typograpy>${ truncate(record.content, 30) }</Typograpy>`
      // }
      const totalCount = info.totalCount
      console.log('totalCount=>', totalCount)
      set_dataList(records)
      set_totalCount(totalCount)
    }
  }

  const fetchChats = async () => {
    const url = `/chat/root/school/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      unreadYn: unreadOnly ? 'Y' : 'N',
      keyword: keyword,
    })
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    return JSON.parse(resp.repMessage)
  }

  // 설정: 문의에 강좌를 지정
  const onDetail = row => {
    recordRef.current = row
    settingHandler[1](true)
  }

  const onDelete = async (id) => {
    const url = `/chat/${id}/school/${schola.id}`
    const resp = await WebService.delete(url, {id: id})
    if (resp.repCode === 'ack') {
      onLoad()
      openSnackbar('삭제되었습니다.')
    } else {
      openSnackbar(resp.repMessage)
    }
  }

  const onCreate = () => {

    const now = moment().format(dateFormat)
    const newRecord = {
      ...defRecord,
      schoolId: schola.id,
      catCode: '',
      title: '',
      content: '',
      activeYn: 'Y',
      fixYn: 'N',
      sTime:'',
      eTime:'',
      day:'',
      time1:'',
      time2:'',
      uptTime: now,
      regTime: now
    }
    recordRef.current = newRecord
    // set_detailScreen(true)
    modHandler[1](true)

  }

  // const onSearch = () => {
  //   onLoad()
  // }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      obj[k] = ''
    })
    set_terms(obj)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage})
  }

  const handleChangeRowsPerPage = (event) => {

    const pageSize = parseInt(event.target.value, pageSize)
    set_pageInfo({pageNum: 0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{flexShrink: 0, ml: 2.5}}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
        </IconButton>
      </Box>
    );
  }

  const applySearch = () => {
    set_pageInfo({ pageNum: 0, pageSize: pageInfo.pageSize })
  }

  const onSearch = () => {
    set_keyword(keywordInput.trim())
    applySearch()
  }

  useEffect(() => {
    if(curLocationRef.current.key !== location.key ) {
      curLocationRef.current = location
      set_pageInfo({ pageNum: 0, pageSize: pageSize })
    }
  },[location])



  useEffect(() => {
    onLoad()
  }, [pageInfo])

  // useEffect(() => {

  // },[records])

  return (
    <div>
      {modHandler[0] ? (
        <MyDialog3
          title={'대화 내용'}
          windowWidth="md"
          dialogHandler={modHandler}
          placeClose={true}
          component=<ManagerChatPartDialog record={recordRef.current} dialogHandler={modHandler} callback={onLoad} />
        />
      ) : null}
      {settingHandler[0] ? (
        <MyDialog3
          title={'문의 설정'}
          windowWidth="sm"
          dialogHandler={settingHandler}
          placeClose={true}
          component=<ManagerChatPartSetting record={recordRef.current} dialogHandler={settingHandler} callback={onLoad} />
        />
      ) : null}
      {viewHandler[0] ? (<ManagerNoticePartView record={recordRef.current} dialogHandler={viewHandler} callback={onLoad}/>) : null}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}>
        <div style={{ paddingRight: 10 }}>
          <h1>문의 관리 </h1>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 16 }}>
        <FormControlLabel
          label="읽지 않음만"
          control={
            <Checkbox
              size="small"
              checked={unreadOnly}
              onChange={e => {
                set_unreadOnly(e.target.checked)
                applySearch()
              }}
            />
          }
        />
        <TextField
          size="small"
          placeholder="학생명"
          value={keywordInput}
          onChange={e => set_keywordInput(e.target.value)}
          onKeyDown={e => {
            // 한글 조합 중 Enter는 무시
            if(e.key === 'Enter' && !e.nativeEvent.isComposing) {
              onSearch()
            }
          }}
        />
        <IconButton size="small" onClick={onSearch}>
          <SearchIcon />
        </IconButton>
      </div>
      <div style={{paddingTop: 20}}>
        <MUITable>
          <MyTableHead>
            <TableRow>
              {
                fields.map((col, index) => {
                  if (col.visible) {
                    return (
                      <TableCell size='small' key={col.field} style={{width: col.width?? null}}>
                        {col.placeholder}
                        {col.canSrch ?
                          (
                            <Fragment>
                              <br/>
                              <TextField label="" variant="outlined" size='small' inputProps={{
                                style: {
                                  fontSize: '0.875em',
                                  padding: 5,
                                  backgroundColor: '#fff'
                                }
                              }}
                                         value={terms[col.field]}
                                         onChange={(e) => {
                                           const newTerms = {...terms}
                                           newTerms[col.field] = e.target.value
                                           set_terms(newTerms)
                                         }}
                              />
                            </Fragment>
                          )
                          : (
                            <Fragment>
                            </Fragment>
                          )
                        }
                      </TableCell>
                    )
                  }
                })
              }
              <TableCell size='small' align={"center"} style={{width: 300}}>
                관리
              </TableCell>
            </TableRow>
          </MyTableHead>
          <TableBody>
            {
              dataList.map((row, rowIdx) => (
                <TableRow key={row.id} onClick={() => {
                  recordRef.current = row
                }}>
                  {fields.map((col, colIdx) => col.visible ? renderCell(row, col, colIdx) : null)}
                  <TableCell size='small' align='center'>
                    <FlatButton style={{ marginRight: 5 }} onClick={() => onDetail(row)} startIcon={<SettingsIcon />}>설정</FlatButton>
                    {
                      isAdmin(account) ? (
                        <ConfirmDialog
                          btn={<FlatButton color='error'>삭제(어드민권한)</FlatButton>}
                          title={'주의'}
                          content={'데이터를 삭제하시겠습니까?'}
                          bc={'warning'}
                          perform={() => {
                            onDelete(row.id)
                          }}
                        />
                      ) : null
                    }

                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                sx={{
                  [`& .${tablePaginationClasses.spacer}`]: {
                    display: "none"
                  },
                  [`& .${tablePaginationClasses.toolbar}`]: {
                    justifyContent: "center"
                  }
                }}
                rowsPerPageOptions={[10, 20, 30, 50, 100, {label: 'All', value: -1}]}
                colSpan={visibleColumns.length + 1}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={
                  ({from, to, count}) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }
                }
                labelRowsPerPage={'페이지당 갯수'}
              />
            </TableRow>
          </TableFooter>
        </MUITable>

        {renderIndicator()}
        {renderAlert()}
      </div>
    </div>
  );

}

export default ManagerChatPage
